import { useSnackbarContext } from './SnackbarProvider'

export const useShowSnackbar = () => useSnackbarContext().showSnackbar
